import styled from "styled-components";
import Text from "./Text";

const CustomButton = styled.button`
  background: none;
  border: none;
  text-align: left;

  &:hover {
    cursor: ${props => props.selected ? "default" : "pointer"};
  }
`;
const ButtonRulesBlock = ({ text, selected, value, onButtonClick }) => {
  return (
  <CustomButton selected={selected} onClick={() => {
    if (!selected) {
      onButtonClick(value)
    }
    }}>
    <Text 
      fontSize="25px"
      fontFamily="Manrope"
      fontWeight="600"
      color={selected ? `var(--highlight)` : `var(--bg-light-blue)`}
      >{text}
    </Text>
  </CustomButton>
  );
}

export default ButtonRulesBlock;
